import { ReactComponent as InfoErrorIcon } from "assets/icons/info-error-icon.svg";
import useFormField from "hooks/form/useFormField";
import * as S from "./ToggleButtons.style";

const ToggleButtons = ({
  title,
  options = [],
  validationRef,
  validationRules,
  initialValue = "",
  onChange,
  half,
}) => {
  const { value, isValid, errorMessage, updateValue, validationId } =
    useFormField({
      initialValue,
      validationRef,
      validationRules,
    });

  return (
    <S.ToggleButtonContainer>
      {title && <S.Title variant="caption-02">{title}</S.Title>}
      <S.SingleOption
        onClick={(e) => e.preventDefault()}
        half={half}
        error={!isValid}
      >
        {options.map(({ value: v, label, disabled }) => (
          <S.ToggleButton
            className="make-click"
            type="button"
            data-validationid={validationId}
            disabled={disabled}
            key={v}
            label={label}
            value={v === value}
            isValid={isValid}
            onChange={() => {
              updateValue(v);
              onChange?.(v);
            }}
          />
        ))}
      </S.SingleOption>
      {!isValid && (
        <S.SectionError>
          <InfoErrorIcon /> &nbsp;
          <S.ErrorMsg variant="caption-01">{errorMessage}</S.ErrorMsg>
        </S.SectionError>
      )}
    </S.ToggleButtonContainer>
  );
};

export default ToggleButtons;
